/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Irrigation_Pump_Sent_OffInputs */

const vi_irrigation_pump_sent_off = /** @type {(inputs: Irrigation_Pump_Sent_OffInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đã gửi lệnh tắt bơm ${i?.name}. Trạng thái sẽ cập nhật khi thiết bị báo về.`)
};

/**

* @param {Irrigation_Pump_Sent_OffInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_pump_sent_off = /** @type {((inputs: Irrigation_Pump_Sent_OffInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Pump_Sent_OffInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_pump_sent_off(inputs)
});